import { createEffect } from 'effector';
import { getBanksApiV1BanksGet } from '~/generated/banksBackend/banks';
import { buildBanksMap } from './lib';
import { type BanksMap } from './model';

export const initializeBanksFx = createEffect<void, BanksMap>(async () => {
    const { banks } = await getBanksApiV1BanksGet(
        {
            popular_only: false,
            limit: 1000,
        },
        {
            context: {
                skipErrorNotification: true,
            },
        },
    );

    return buildBanksMap(banks);
});
